import { styled } from '@mui/system';
import Button, { ButtonProps } from '@mui/material/Button';

const CustomOutlineButton = styled(Button)(({ theme }: any) => ({
  margin: '1em auto',
  borderRadius: '2em',
  minWidth: '100%',
  border: `2px solid ${theme.palette.primary.light}`,
  color: theme.palette.primary.main,
  padding: '.8em 2em',
  textTransform: 'none',
  fontSize: '1em',
  '&:hover': {
    border: `2px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
  },
}));

const OutlineButton: React.FC<ButtonProps> = (props) => <CustomOutlineButton {...props} />;

export default OutlineButton;

